import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useHandleRazorPayment from "./paymentRazorpay";

const useQuery = () => new URLSearchParams(useLocation().search);

const RazorpayAutoTrigger = () => {
    const query = useQuery();
    const amount = query.get("amount");
    const songTitle = query.get("songTitle");
    const campaignId = query.get("campaignId");

    const handlePayment = useHandleRazorPayment();

    const hasCalledRef = useRef(false);

    useEffect(() => {
        if (hasCalledRef.current) return;

        if (amount && songTitle && campaignId) {
            hasCalledRef.current = true; // mark as called
            handlePayment({
                packageAmount: { PackageAmount: amount },
                songId: { songTitle },
                promotionData: { id: campaignId },
            });
        } else {
            alert("Missing payment parameters.");
        }
    }, [handlePayment, amount, songTitle, campaignId]);


    return (
        <div style={{ textAlign: "center", marginTop: "40vh" }}>
            <h3>Processing your payment...</h3>
        </div>
    );
};

export default RazorpayAutoTrigger;
